const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  createClaimOrderSubtnosPrepare ({ state, commit, rootState }, params) {
    return rootState.axios.post('/timeins/v1frontend/timeins/create-claim-ordersubtnos-prepare', params)
  },
  createClaimOrderSubtnos ({ state, commit, rootState }, params) {
    return rootState.axios.post('/timeins/v1frontend/timeins/create-claim-ordersubtnos', params)
  },
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/timeins/v1frontend/timeins/search', {})
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
  }
}
